module.exports = __webpack_public_path__ + "static/media/header-img.f1c1f7ee.png";